
export interface ExamTasksCriteriaFilter {
    id: string;
    criterionNumber: string;
    pointsFilterType?: PointsFilterType;
    exactPoints: number | null;
    pointsFrom: number | null;
    pointsTo: number | null;
}

export interface ExamTaskFilter {
    id: string;
    taskNumber: string;
    pointsFilterType?: PointsFilterType;
    exactPoints: number | null;
    pointsFrom: number | null;
    pointsTo: number | null;
    noAnswer: number | null;
    examScoringSchemas: ExamTasksCriteriaFilter[];
}

export interface AdvanceFilter {
    examTasks: ExamTaskFilter[];
}

export enum PointsFilterType {
    exactPonts = 'Dokładna liczba punktów',
    rangePonts = 'Zakres punktów',
}